/* eslint-disable no-underscore-dangle,eqeqeq,no-unused-expressions,no-plusplus,no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import { FormattedMessage } from 'react-intl';
import PageSectionHeader from '../../containers/FastCover/components/PageSectionHeader/index';
import FNOLTooltip from '../FNOLTooltip';
import Asterisk from '../Asterisk';
/*
 This class and all its dependencies (ErrorMessage, messages) were copied from the react-validate repository
 (https://github.com/lostpebble/react-validate)
 We have made some modification on the code as there seems to be some bugs in the project that
 does not work as expected.
 */
export default class Validate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      multipleChildren: Array.isArray(this.props.children),
      uncontrolled: true,
      childValue: props.defaultValue,
      validity: null,
      showError: false,
      id: this.props.id.length ? this.props.id : uniqueId('valinpt_'),
      errors: {},
      name: this.props.name || uniqueId('field_'),
    };
    // console.dir(props);

    this.onBlur = this.onBlur.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this._getChild = this._getChild.bind(this);

    // variable outside of setState to
    // trustfully hold most recent state
    this.recentChange = null;

    if (this.props.addValidatorToGroup) {
      this.props.addValidatorToGroup(this.state.id);
    }
    if (this.props.group) {
      this.props.group.addField(this.state.name);
    }
  }

  componentWillMount() {
    const startingValue = this._getChild(this.props.children).props[this.props.propForValue];

    // const startingValue = "what";
    if (typeof startingValue !== 'undefined') {
      // console.log(`Component ${this.state.id} is controlled, has a value`);

      this.setState({
        uncontrolled: false,
        childValue: startingValue,
      });
    }

    this._checkValidation(
      this.state.uncontrolled ? this.state.childValue : startingValue,
      !this.props.feedbackOnMount,
    );
  }

  componentWillReceiveProps(nextProps) {
    // If child component is controlled (ie. has a value prop) then this is
    // where we hook into checking the validation on that component
    // since when the value changes- this component will receive that change
    // as new props too. To ensure that we don't make more checks than
    // necessary we save every change in this.recentChange and check against it
    let forceValidation = false;
    if (nextProps.validationCounter && nextProps.validationCounter != this.props.validationCounter) {
      forceValidation = true;
      this.state.showError = true;
    }

    if (!this.state.uncontrolled) {
      const newValue = this._getChild(nextProps.children).props[
        this.props.propForValue
        ];
      if (newValue !== this.recentChange || forceValidation) {
        this._checkValidation(
          newValue,
          !this.state.showError ? !this.props.impatientFeedback : false,
        );
      }
    }
  }

  componentWillUnmount() {
    const { validatorLeaveGroup, group } = this.props;
    const { name } = this.state;
    validatorLeaveGroup && this.props.validatorLeaveGroup(this.state.id);
    group && group.clearErrorMessages(name);
  }

  onValueChange(...args) {
    setTimeout(() => {
      let newValue = args[this.props.onChangeValuePosition];
      // Some control return array instead of element, so we update the value directly
      if (!Array.isArray(newValue)) {
        newValue = this.props.onChangeValueKeys.toString();
      }

      this.setState({
        childValue: newValue,
      }, () => {
        this._checkValidation(
          newValue,
         false,
        );
      });
    });
  }

  onBlur() {
    // don't check validation on blur if it's already been

    // checked impatiently on every change

    if (!this.props.impatientFeedback) {
      const childComponent = this.props.children.find((children) => children.type.name !== 'ErrorMessage');
      this._checkValidation(
        this.state.uncontrolled
          ? this.state.childValue
          : childComponent.props[this.props.propForValue],
      );
    }
  }

  _getChild(children) {
    if (this.state.multipleChildren) {
      if (this.props.index >= 0) {
        return children[this.props.index];
      }

      for (let i = 0; i < children.length; i++) {
        if (children[i].type.name !== 'ErrorMessage') {
          return children[i];
        }
      }
    }

    return children;
  }

  _interceptChange(originalOnChange) {
    return (...args) => {
      if (typeof originalOnChange === 'function') {
        originalOnChange(...args);
      }

      this.onValueChange(...args);
    };
  }

  _checkValidation(value, patientError) {
    let newValidity = true;

    this.recentChange = value;
    const errors = {};

    if (!this.props.validators.length) {
      // If no validator just check for truthy value

      if (!value) {
        newValidity = false;
      }
    } else {
      try {
        // newValidity = !this.props.validators.some(
        //   validator => !validator(value)
        // );

        // Store error based criteria name
        this.props.validators.forEach((validator) => {
          if (!validator(value)) {
            errors[validator.name] = true;
            // has error
            newValidity = false;
          }
        });
      } catch (e) {
        console.error(e);
      }
    }

    const state = {};

    state.errors = errors;

    if (!patientError) {
      if (this.state.showError !== !newValidity) {
        state.showError = !newValidity;
        if (this.props.onErrorChange) {
          this.props.onErrorChange(
            !newValidity,
            this.props.errorText,
            this.state.id,
          );
        }
      }
    }

    if (this.state.validity !== newValidity) {
      state.validity = newValidity;

      if (this.props.onValidChange) {
        this.props.onValidChange(newValidity);
      }

      if (this.props.validChangeInGroup) {
        this.props.validChangeInGroup(newValidity, this.state.id);
      }
    }

    if (this.props.group) {
      this.props.group.validFieldChange(this.state.name, !state.validity && state.showError);
    }

    this.setState(state);
  }

  render() {
    const { name } = this.state;
    const { fieldName, tooltipContent, tooltipDataFor, tooltipPlace } = this.props;
    // clear error message
    this.props.group.clearErrorMessages(name);

    const children = React.Children.map(
      this.props.children,

      (child, index) => {
        // Return null if child is null or falsy
        if (!child) {
          return null;
        }

        if (child && child.type && child.type.name === 'ErrorMessage') {
          if (this.state.errors[typeof child.props.for == 'function' ? child.props.for.name : child.props.for]) {
            return React.cloneElement(child, { visible: this.state.showError });
            // save error message to the list
            // if (this.props.group) {
            //   this.props.group.addErrorMessage({
            //     field: name,
            //     message: child.props.children,
            //     validator: child.props.for,
            //   });
            // }
          }
          return null;
        }

        // explicit index set and current child isn't that one

        if (this.props.index >= 0 && index !== this.props.index) {
          return React.cloneElement(child, {});
        }

        const baseProps = {
          onBlur: this.onBlur,
        };

        if (this.props.passError) {
          baseProps[this.props.propForErrorText] = this.state.showError
            ? this.props.errorText
            : '';
        }

        if (this.props.propForShowError.length) {
          baseProps[this.props.propForShowError] = this.state.showError;
        }

        if (this.state.uncontrolled) {
          baseProps[this.props.propForOnChange] = this._interceptChange(
            child.props[this.props.propForOnChange],
          );

          baseProps[this.props.propForValue] = this.state.childValue;
        }

        return React.cloneElement(child, baseProps);
      },

      this,
    );

    return (
      <div
        className={`${this.props.className} ${
          this.state.validity ? 'valid' : 'invalid'
          } ${this.state.showError ? 'error' : ''}`}
      >
        {fieldName &&
        <PageSectionHeader>
            <FormattedMessage {...fieldName} />&nbsp;<Asterisk />&nbsp;{!!tooltipContent && <FNOLTooltip dataFor={tooltipDataFor} content={tooltipContent} place={tooltipPlace} />}
        </PageSectionHeader>
        }
        <div className="input-container">
          {children}
        </div>
      </div>
    );
  }
}

Validate.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),

  id: PropTypes.string,
  validators: PropTypes.array.isRequired,
  index: PropTypes.number,
  onChangeValuePosition: PropTypes.number,
  onChangeValueKeys: PropTypes.array,
  errorText: PropTypes.string,
  className: PropTypes.string,
  propForValue: PropTypes.string,
  propForShowError: PropTypes.string,
  propForErrorText: PropTypes.string,
  propForOnChange: PropTypes.string,
  onValidChange: PropTypes.func,
  onErrorChange: PropTypes.func,
  passError: PropTypes.bool,
  impatientFeedback: PropTypes.bool,
  feedbackOnMount: PropTypes.bool,
  group: PropTypes.object.isRequired,
  // name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  name: PropTypes.any,
  addValidatorToGroup: PropTypes.any,
  validationCounter: PropTypes.any,
  validatorLeaveGroup: PropTypes.any,
  validChangeInGroup: PropTypes.any,
  fieldName: PropTypes.any,
  tooltipContent: PropTypes.any,
  tooltipDataFor: PropTypes.any,
  tooltipPlace: PropTypes.any,
};

Validate.defaultProps = {
  id: '',
  index: -1,
  defaultValue: '',
  onChangeValuePosition: 0,
  onChangeValueKeys: ['target', 'value'],
  propForShowError: '',
  propForErrorText: 'errorText',
  propForValue: 'value',
  propForOnChange: 'onChange',
  validators: [],
  errorText: '',
  passError: false,
  impatientFeedback: false,
  feedbackOnMount: false,
  className: 'rv-validate-component',
};



// WEBPACK FOOTER //
// ./app/components/Validation/Validate.js